import { BrowserRouter as Router } from 'react-router-dom'
import { CssBaseline } from '@mui/material'
import GlobalStyle from 'commons/styles/GlobalStyle'
import HVNTheme from 'commons/styles/HAVTheme'
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles'
import 'fonts.css'
import 'toast.css'
import Routes from './routes'
import { persistor, store } from 'store/store'
import { PersistGate } from 'redux-persist/integration/react'
import { Provider } from 'react-redux'
import { ToastContainer } from 'react-toastify'
import { AppInsightsContext } from '@microsoft/applicationinsights-react-js'
import { reactPlugin } from 'services/telemetry/AppInsights'

function App() {
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={HVNTheme}>
        <CssBaseline />
        <GlobalStyle />
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <AppInsightsContext.Provider value={reactPlugin}>
              <Router>
                <Routes />
              </Router>
            </AppInsightsContext.Provider>
          </PersistGate>
        </Provider>
      </ThemeProvider>
    </StyledEngineProvider>
  )
}

export default App
